// Maps domain status values to badge utility classes
export function statusToClass(status?: string): string {
  if (!status) return 'badge badge-neutral';
  const key = status.toLowerCase();
  if (['active','approved','success','completed','paid'].includes(key)) return 'badge badge-success';
  if (['error','failed','rejected','declined','terminated','unpaid'].includes(key)) return 'badge badge-error';
  if (['pending','in progress','processing','open','waiting'].includes(key)) return 'badge badge-neutral';
  if (['warning','at risk','risk'].includes(key)) return 'badge badge-warning';
  if (['info','information'].includes(key)) return 'badge badge-info';
  return 'badge badge-neutral';
}
